/* Fetcheroni Yak Advertorial — sticky bar + gallery + variant picker + modal */
(function(){

  // Sticky bar: appears only after meaningful scroll past hero AND methodology,
  // hides while user is anywhere near the inline buy box, hides near footer
  (function(){
    var sticky = document.getElementById('sticky');
    var bb = document.getElementById('buybox');
    var hero = document.querySelector('.hero');
    var finalCta = document.querySelector('.final');
    if (!sticky || !bb || !hero || !finalCta) return; // section optional — bail without breaking rest of script
    function check() {
      var heroBottom = hero.getBoundingClientRect().bottom;
      var bbRect = bb.getBoundingClientRect();
      var finalRect = finalCta.getBoundingClientRect();
      var visible = window.innerHeight;
      var pastHero = heroBottom < -visible*0.5;
      var nearBuyBox = bbRect.top < visible*1.2 && bbRect.bottom > -visible*0.2;
      var nearFinal = finalRect.top < visible*0.9;
      if (pastHero && !nearBuyBox && !nearFinal) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  })();

  // Gallery + variant picker + ATC
  (function(){
    var gallery = document.querySelector('.buybox-gallery');
    if (!gallery) return;
    var main = document.getElementById('buyboxMainImage');
    var thumbs = gallery.querySelectorAll('.buybox-thumbs img');
    var picker = document.querySelector('.picker');
    var form = document.querySelector('[data-fyk-cart-form]');

    // Sticky flag: once user manually picks a thumb, variant clicks stop
    // overriding the main image until page reload.
    var userPickedThumb = false;

    function setMain(src){
      if (!main || !src) return;
      // Strip width param so comparison is robust across thumb (240) vs main (1000) widths.
      function bare(u){ return (u || '').split('?')[0]; }
      if (bare(main.src) === bare(src)) {
        // Same image — still sync active thumb borders
        thumbs.forEach(function(t){ t.classList.toggle('is-active', bare(t.src) === bare(src)); });
        return;
      }
      main.classList.add('is-swapping');
      setTimeout(function(){
        main.src = src;
        thumbs.forEach(function(t){ t.classList.toggle('is-active', bare(t.src) === bare(src)); });
        requestAnimationFrame(function(){ main.classList.remove('is-swapping'); });
      }, 120);
    }

    // Enter/Space activates a click on keyboard-focusable custom controls
    function keyActivate(el){
      el.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          el.click();
        }
      });
    }

    // Thumbnail clicks
    thumbs.forEach(function(thumb){
      thumb.addEventListener('click', function(){
        userPickedThumb = true;
        // Prefer a high-res override if the section provides one, else fall back to thumb src
        var hi = thumb.getAttribute('data-fullsrc') || thumb.src;
        setMain(hi);
      });
      keyActivate(thumb);
    });

    // Variant picker
    if (picker) {
      picker.querySelectorAll('.opt').forEach(function(opt){
        keyActivate(opt);
        opt.addEventListener('click', function(){
          picker.querySelectorAll('.opt').forEach(function(o){
            o.classList.remove('is-active');
            o.setAttribute('aria-checked', 'false');
          });
          opt.classList.add('is-active');
          opt.setAttribute('aria-checked', 'true');

          // Update ATC button label price
          var atcBtn = document.querySelector('.buybox .atc');
          var stack = opt.querySelector('.price-stack');
          if (atcBtn && stack) {
            // The current price is the last text node (after any compare-at span)
            var priceText = stack.textContent.trim();
            // strip any leading "was" price prefix — grab the final $X.XX in the string
            var m = priceText.match(/\$[0-9][0-9,.]*\s*$/);
            var price = m ? m[0].trim() : priceText;
            atcBtn.textContent = 'Add to cart — ' + price;
          }

          // Update the hidden id input so the form submits the right variant
          if (form) {
            var idInput = form.querySelector('input[name="id"]');
            var variantId = opt.getAttribute('data-variant');
            // Only update if data-variant looks like a Shopify variant id (numeric)
            if (idInput && variantId && /^\d+$/.test(variantId)) {
              idInput.value = variantId;
            }
          }

          // Swap the main image to this variant — unless user deliberately picked a thumb
          if (!userPickedThumb) {
            var variantImg = opt.getAttribute('data-image');
            if (variantImg) setMain(variantImg);
          }
        });
      });
    }

    // Quantity +/- buttons
    if (form) {
      var qtyWrap = form.querySelector('.qty');
      if (qtyWrap) {
        var qtyInput = qtyWrap.querySelector('input');
        var qtyBtns = qtyWrap.querySelectorAll('button');
        if (qtyInput && qtyBtns.length === 2) {
          qtyBtns[0].addEventListener('click', function(){
            var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
            qtyInput.value = v;
          });
          qtyBtns[1].addEventListener('click', function(){
            var v = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1);
            qtyInput.value = v;
          });
        }
      }
    }

    // AJAX add-to-cart for the wired form
    if (form) {
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var atcBtn = form.querySelector('.atc');
        if (!atcBtn || atcBtn.disabled) return;
        var orig = atcBtn.textContent;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding…';

        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: fd
        })
        .then(function(r){
          if (!r.ok) return r.json().then(function(j){ throw j; });
          return r.json();
        })
        .then(function(){
          // Pull fresh cart and feed the FET cart-drawer
          return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function(r){ return r.json(); });
        })
        .then(function(cart){
          atcBtn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
          setTimeout(function(){
            atcBtn.textContent = orig;
            atcBtn.disabled = false;
          }, 1400);
        })
        .catch(function(err){
          console.error('FET ATC error', err);
          atcBtn.textContent = (err && err.description) ? 'Out of stock' : 'Error — try again';
          setTimeout(function(){
            atcBtn.textContent = orig;
            atcBtn.disabled = false;
          }, 1800);
        });
      });
    }
  })();

  // Variant picker modal — opens from sticky + final CTA + any data-open-modal trigger
  (function(){
    var backdrop = document.getElementById('variantModal');
    if (!backdrop) return;
    function open(){
      backdrop.classList.add('is-open');
      backdrop.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
    }
    function close(){
      backdrop.classList.remove('is-open');
      backdrop.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-open-modal]').forEach(function(el){
      el.addEventListener('click', function(e){ e.preventDefault(); open(); });
    });
    backdrop.addEventListener('click', function(e){
      if (e.target === backdrop) close();
    });
    document.querySelectorAll('[data-close-modal]').forEach(function(el){
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && backdrop.classList.contains('is-open')) close();
    });

    // Modal AJAX add — submits each <form class="vcard"> via /cart/add.js, opens drawer
    backdrop.querySelectorAll('form.vcard').forEach(function(vform){
      vform.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = vform.querySelector('.vadd');
        if (!btn || btn.disabled) return;
        var orig = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        var fd = new FormData(vform);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: fd
        })
        .then(function(r){ if (!r.ok) return r.json().then(function(j){ throw j; }); return r.json(); })
        .then(function(){
          return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function(r){ return r.json(); });
        })
        .then(function(cart){
          btn.textContent = 'Added ✓';
          btn.style.background = 'var(--green)';
          btn.style.boxShadow = '0 3px 0 0 var(--green-dk)';
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          close();
          document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
          setTimeout(function(){
            btn.textContent = orig;
            btn.style.background = '';
            btn.style.boxShadow = '';
            btn.disabled = false;
          }, 1600);
        })
        .catch(function(err){
          console.error('FET modal ATC error', err);
          btn.textContent = 'Error — try again';
          setTimeout(function(){
            btn.textContent = orig;
            btn.disabled = false;
          }, 1800);
        });
      });
    });
  })();

  // Test-section swipe carousel dots — wires each .case-grid[data-fyk-rail]
  // to the sibling .case-dots, on mobile widths only.
  (function(){
    var mq = window.matchMedia('(max-width: 620px)');
    document.querySelectorAll('[data-fyk-rail]').forEach(function(rail){
      var dots = rail.parentNode.querySelector('[data-fyk-dots]');
      if (!dots) return;
      var cards = rail.querySelectorAll('.case');
      if (cards.length < 2) return;
      cards.forEach(function(_, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show review ' + (i+1));
        b.addEventListener('click', function(){
          cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        dots.appendChild(b);
      });
      var dotEls = dots.querySelectorAll('button');
      var io = new IntersectionObserver(function(entries){
        if (!mq.matches) return;
        entries.forEach(function(e){
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            var idx = [].indexOf.call(cards, e.target);
            dotEls.forEach(function(d, i){ d.classList.toggle('is-active', i === idx); });
          }
        });
      }, { root: rail, threshold: [0.6, 0.9] });
      cards.forEach(function(c){ io.observe(c); });
      if (dotEls[0]) dotEls[0].classList.add('is-active');
    });
  })();

  // "Pick a pack" CTA (and any #buybox link) → anchor the product image just below
  // the sticky header so the picker + ATC come into view below it.
  (function(){
    function frameBuybox(e){
      var gallery = document.querySelector('.buybox-gallery');
      var bb = document.getElementById('buybox');
      var target = gallery || bb;
      if (!target) return; // no JS target — let the default anchor jump happen
      e.preventDefault();
      var headerOffset = 80; // clear the ~61px sticky header + breathing room
      var y = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerOffset);
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    document.querySelectorAll('a[href$="#buybox"]').forEach(function(link){
      link.addEventListener('click', frameBuybox);
    });
  })();

})();
